import SubscriptionListModel from "./models/SubscriptionListModel";
import DeleteSubscriptionModel from "./models/DeleteSubscriptionModel";

const SubscriptionListStore = {
  name: 'SubscriptionListStore',
  spec: SubscriptionListModel,
  saveLocally: false,
  initialState: {
    subscriptions: []
  },
};
const DeleteSubscriptionStore = {
  name: 'DeleteSubscriptionStore',
  spec: DeleteSubscriptionModel,
  saveLocally: false,
  initialState: {
    res:"Oops...Something went wrong. Please try again."
  }
};

const stores = [SubscriptionListStore, DeleteSubscriptionStore];

export default stores;